import { Brain, Code2, Compass, Microscope, ArrowUpRight } from "lucide-react";
import { Link } from "react-router-dom";

const services = [
  {
    icon: Brain,
    title: "AI Solutions",
    body: "LLM copilots, computer vision, forecasting and MLOps — engineered for reliability, not demos.",
    span: "md:col-span-7",
    stack: ["LLMs", "CV", "Time-Series", "MLOps"],
  },
  {
    icon: Code2,
    title: "Product Development",
    body: "Full-stack squads shipping SaaS, mobile and edge products from zero-to-one to scale.",
    span: "md:col-span-5",
    stack: ["React", "FastAPI", "Postgres", "AWS"],
  },
  {
    icon: Compass,
    title: "Consulting",
    body: "Strategy, tech due-diligence and org design for leaders operationalising AI at scale.",
    span: "md:col-span-5",
    stack: ["Strategy", "Diligence", "OrgDesign"],
  },
  {
    icon: Microscope,
    title: "Technology Research",
    body: "Applied research squads exploring frontier techniques with clear paths to product.",
    span: "md:col-span-7",
    stack: ["R&D", "PoC", "Papers", "Patents"],
  },
];

export const Services = () => {
  return (
    <section
      data-testid="services-section"
      id="services"
      className="relative py-24 md:py-32"
    >
      <div className="container-x">
        <div className="flex flex-col md:flex-row md:items-end md:justify-between gap-6 mb-14">
          <div>
            <div className="font-mono-label text-xs text-[#00F0FF] mb-4">
              / 01 — What we do
            </div>
            <h2
              data-testid="services-heading"
              className="font-display text-4xl sm:text-5xl lg:text-6xl text-white tracking-tight max-w-2xl"
            >
              Four practices. One outcome:{" "}
              <span className="text-[#00FF66]">shipped intelligence.</span>
            </h2>
          </div>
          <p className="text-white/60 max-w-md leading-relaxed">
            We don&apos;t sell decks. We embed with your team, ship real systems,
            and hand over the keys with documentation, monitoring and a
            trained internal team.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-12 gap-6">
          {services.map((s, i) => {
            const Icon = s.icon;
            return (
              <div
                key={s.title}
                data-testid={`service-card-${i}`}
                className={`group relative ${s.span} col-span-1 rounded-2xl border border-white/10 bg-[#0F0F13] p-8 md:p-10 transition-transform duration-300 hover:-translate-y-1 hover:border-[#00F0FF]/40`}
              >
                <div className="flex items-start justify-between">
                  <div className="w-12 h-12 rounded-xl grid place-items-center bg-[#00F0FF]/10 border border-[#00F0FF]/30 text-[#00F0FF]">
                    <Icon size={22} strokeWidth={1.75} />
                  </div>
                  <ArrowUpRight
                    size={20}
                    className="text-white/30 group-hover:text-[#00F0FF] transition-colors"
                  />
                </div>

                <h3 className="mt-8 font-display text-2xl md:text-3xl text-white tracking-tight">
                  {s.title}
                </h3>
                <p className="mt-3 text-white/60 leading-relaxed max-w-lg">
                  {s.body}
                </p>

                <div className="mt-6 flex flex-wrap gap-2">
                  {s.stack.map((t) => (
                    <span
                      key={t}
                      className="text-[10px] font-mono-label px-2.5 py-1 rounded-full border border-white/10 text-white/60"
                    >
                      {t}
                    </span>
                  ))}
                </div>
              </div>
            );
          })}
        </div>

        <div className="mt-14 flex items-center justify-center">
          <Link
            to="/services"
            data-testid="services-cta"
            className="inline-flex items-center gap-2 text-sm text-white/70 hover:text-[#00F0FF] transition-colors font-mono-label"
          >
            SEE THE FULL SERVICE MAP <ArrowUpRight size={14} />
          </Link>
        </div>
      </div>
    </section>
  );
};

export default Services;
